<template>
	<v-card elevation="0" class="mx-auto" max-width="800">
		<div class="sticky-header">
			<v-card-title class="headline font-weight-light">{{
				location.details.name
			}}</v-card-title>
			<v-card-subtitle class="pb-0 font-weight-medium"
				>{{ location.rooms.length }}
				{{ $t('reserve.roomsAvailable') }}</v-card-subtitle
			>
			<!-- <v-card-text
			class="text--primary"
			v-html="location.details.description"
		>
		</v-card-text> -->
		</div>

		<co-room-list :rooms="location.rooms"></co-room-list>
	</v-card>
</template>

<script>
import CoRoomList from './room-list';

export default {
	name: 'co-location-rooms',
	props: ['location'],
	components: { CoRoomList },
	data() {
		return {
			keyword: ''
		};
	},
	created() {
		this.keyword = window.config.keyword;
	}
};
</script>
<style lang="scss" scoped>
.sticky-header {
	position: sticky;
	top: 200px;
	background-color: #ffffff;
	z-index: 1;
}
</style>
